import Api from './ApiRequest';

export default {
    getAll: (params) => Api.get('/cent/reports', params),
    getById: (id) => Api.get('/cent/report/' + id, null),
    getSharedResults: (key) => Api.get(`/cent/report/shared/${key}/results`),
    save: (entity) => Api.post('/cent/report', entity),
    update: (id, entity) => Api.put('/cent/report/' + id, entity),
    delete: (id) => Api.delete('/cent/report/' + id),
    search: (searchText) => Api.get('/cent/reports/search', {q: searchText}),
    getReportTypes: () => Api.get('/cent/reports/types'),
    getResults: (id) => Api.get('/cent/report/'+ id + '/results'),
    emailResults: (id, params) => Api.post(`/cent/report/${id}/email`, params),
    getShare: (reportId) => Api.get(`/cent/report/${reportId}/share`),
    addShare: (reportId) => Api.post(`/cent/report/${reportId}/share`),
    deleteShare: (shareKey) => Api.delete(`/cent/report/shared/${shareKey}`),
    listSchedules: () => Api.get(`/cent/report/schedules`),
    getSchedule: (scheduleId) => Api.get(`/cent/report/schedule/${scheduleId}`),
    addSchedule: (reportId, data) => Api.post(`/cent/report/${reportId}/schedule`, data),
    updateSchedule: (scheduleId, data) => Api.put(`/cent/report/schedule/${scheduleId}`, data),
    deleteSchedule: (scheduleId) => Api.delete(`/cent/report/schedule/${scheduleId}`)
};